import React, { useState, useEffect } from "react";

const MetadataEditor = ({ fileMetadata, onMetadataChange, disabled }) => {
  const [metadata, setMetadata] = useState(fileMetadata);

  useEffect(() => {
    setMetadata(fileMetadata);
  }, [fileMetadata]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newMetadata = {
      ...metadata,
      [name]: value,
    };
    setMetadata(newMetadata);
    onMetadataChange(newMetadata);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <h3>メタデータ編集 ✍️</h3>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxWidth: "400px",
          margin: "0 auto",
        }}
      >
        <div>
          <label
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            曲名
          </label>
          <input
            type="text"
            name="title"
            value={metadata.title || ""}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            disabled={disabled}
          />
        </div>
        <div>
          <label
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            アーティスト名
          </label>
          <input
            type="text"
            name="artist"
            value={metadata.artist || ""}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            disabled={disabled}
          />
        </div>
        <div>
          <label
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            アルバム名
          </label>
          <input
            type="text"
            name="album"
            value={metadata.album || ""}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataEditor;
//MetadataEditor.js